"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var Dimension = _react2["default"].createClass({
  displayName: "Dimension",

  PropTypes: {
    handleDimension: _react2["default"].PropTypes.func.isRequired
  },
  handleDimension: function handleDimension(e) {
    e.preventDefault();
    this.props.handleDimension(e.target.value);
  },
  render: function render() {
    return _react2["default"].createElement(
      "div",
      { className: "choose" },
      _react2["default"].createElement(
        "span",
        null,
        "Look at "
      ),
      _react2["default"].createElement(
        "select",
        { onChange: this.handleDimension },
        _react2["default"].createElement(
          "option",
          { value: "Country" },
          "Countries"
        ),
        _react2["default"].createElement(
          "option",
          { value: "Category" },
          "Categories"
        )
      )
    );
  }
});
exports.Dimension = Dimension;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9jb250cm9sL2RpbWVuc2lvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OztxQkFBa0IsT0FBTzs7OztBQUVsQixJQUFNLFNBQVMsR0FBRyxtQkFBTSxXQUFXLENBQUM7OztBQUN6QyxXQUFTLEVBQUM7QUFDUixtQkFBZSxFQUFHLG1CQUFNLFNBQVMsQ0FBQyxJQUFJLENBQUMsVUFBVTtHQUNsRDtBQUNELGlCQUFlLEVBQUEseUJBQUMsQ0FBQyxFQUFDO0FBQ2hCLEtBQUMsQ0FBQyxjQUFjLEVBQUUsQ0FBQTtBQUNsQixRQUFJLENBQUMsS0FBSyxDQUFDLGVBQWUsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO0dBQzNDO0FBQ0QsUUFBTSxFQUFBLGtCQUFFO0FBQ04sV0FDRTs7UUFBSyxTQUFTLEVBQUMsUUFBUTtNQUNyQjs7OztPQUFxQjtNQUNyQjs7VUFBUSxRQUFRLEVBQUUsSUFBSSxDQUFDLGVBQWUsQUFBQztRQUNyQzs7WUFBUSxLQUFLLEVBQUMsU0FBUzs7U0FBbUI7UUFDMUM7O1lBQVEsS0FBSyxFQUFDLFVBQVU7O1NBQW9CO09BQ3JDO0tBQ0wsQ0FDUDtHQUNGO0NBQ0YsQ0FBQyxDQUFBIiwiZmlsZSI6Ii9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9jb250cm9sL2RpbWVuc2lvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcblxuZXhwb3J0IGNvbnN0IERpbWVuc2lvbiA9IFJlYWN0LmNyZWF0ZUNsYXNzKHtcbiAgUHJvcFR5cGVzOntcbiAgICBoYW5kbGVEaW1lbnNpb24gOiBSZWFjdC5Qcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkXG4gIH0sXG4gIGhhbmRsZURpbWVuc2lvbihlKXtcbiAgICBlLnByZXZlbnREZWZhdWx0KClcbiAgICB0aGlzLnByb3BzLmhhbmRsZURpbWVuc2lvbihlLnRhcmdldC52YWx1ZSlcbiAgfSxcbiAgcmVuZGVyKCl7XG4gICAgcmV0dXJuIChcbiAgICAgIDxkaXYgY2xhc3NOYW1lPVwiY2hvb3NlXCI+XG4gICAgICAgIDxzcGFuPkxvb2sgYXQgPC9zcGFuPlxuICAgICAgICA8c2VsZWN0IG9uQ2hhbmdlPXt0aGlzLmhhbmRsZURpbWVuc2lvbn0+XG4gICAgICAgICAgPG9wdGlvbiB2YWx1ZT1cIkNvdW50cnlcIj5Db3VudHJpZXM8L29wdGlvbj5cbiAgICAgICAgICA8b3B0aW9uIHZhbHVlPVwiQ2F0ZWdvcnlcIj5DYXRlZ29yaWVzPC9vcHRpb24+XG4gICAgICAgIDwvc2VsZWN0PlxuICAgICAgPC9kaXY+XG4gICAgKVxuICB9XG59KSJdfQ==